"use client"

import { GitBranchMinus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GitBranchMinusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GitBranchMinusIcon = component(Icon)({ as: GitBranchMinus })
